import { Typography } from '@mui/material'
import React from 'react'

import { useGetPlan } from '@/app/module/plans/hooks/use-get-plan'
import { useGetInvitations } from '@/app/module/user/hooks/use-get-invitations'

type Props = {}

const UserAccountsUsage: React.FC<Props> = () => {
  const { data: orgPlan } = useGetPlan()
  const { data: invitationsData } = useGetInvitations()

  const invitationCounts = invitationsData?.invites?.length || 0
  const usersCounts = orgPlan?.usersNow || 0

  if (!orgPlan) {
    return null
  }

  return (
    <Typography color="textSecondary" variant="subtitle1">
      <b>{usersCounts + invitationCounts}</b>/<b>{orgPlan.usersIncluded}</b> users and invitations
    </Typography>
  )
}

export default UserAccountsUsage
